import { ERROR_MESSAGES } from '@/constants/errorMessages'

export class ApiError extends Error {
  status?: number
  constructor(message: string, option?: { cause?: unknown; status?: number }) {
    super(message, { cause: option?.cause })
    this.status = option?.status
  }
}

const isServerError = (error: ApiError) => {
  return error.status && error.status >= 500
}

export const handleUnknownApiError = (error: unknown): ApiError => {
  console.error(error)
  if (error instanceof ApiError) {
    // 500系の場合はユーザーフレンドリーでないメッセージの可能性が高いのでデフォルトのエラーメッセージを返す
    if (isServerError(error)) {
      return new ApiError(ERROR_MESSAGES.defaultApiError, { cause: error })
    }
    return error
  }
  return new ApiError(ERROR_MESSAGES.defaultApiError, { cause: error })
}
